import { getTranslatedText } from '@nile/components/src';

const OPERATORMAP = (intl) => {
  const operatorMap = {
    after: getTranslatedText(intl, 'admin.slaPolicy.after.operator'),
    before: getTranslatedText(intl, 'admin.slaPolicy.before.operator'),
    between: getTranslatedText(intl, 'admin.slaPolicy.betweeen.operator'),
    contains: getTranslatedText(intl, 'admin.slaPolicy.contains.operator'),
    endsWith: getTranslatedText(intl, 'admin.slaPolicy.endsWith.operator'),
    greaterThan: getTranslatedText(
      intl,
      'admin.slaPolicy.greaterThan.operator'
    ),
    greaterThanOrEqual: getTranslatedText(
      intl,
      'admin.slaPolicy.greaterThanOrEqual.operator'
    ),
    inLast: getTranslatedText(intl, 'admin.slaPolicy.inLast.operator'),
    notInLast: getTranslatedText(intl, 'admin.slaPolicy.notInLast.operator'),
    inNext: getTranslatedText(intl, 'admin.slaPolicy.inNext.operator'),
    includes: getTranslatedText(intl, 'admin.slaPolicy.includes.operator'),
    is: getTranslatedText(intl, 'admin.slaPolicy.is.operator'),
    isEmpty: getTranslatedText(intl, 'admin.slaPolicy.isEmpty.operator'),
    isNot: getTranslatedText(intl, 'admin.slaPolicy.isNot.operator'),
    isNotEmpty: getTranslatedText(intl, 'admin.slaPolicy.isNotEmpty.operator'),
    lessThan: getTranslatedText(intl, 'admin.slaPolicy.lessThan.operator'),
    lessThanOrEqual: getTranslatedText(
      intl,
      'admin.slaPolicy.lessThanOrEqual.operator'
    ),
    notContains: getTranslatedText(
      intl,
      'admin.slaPolicy.notContains.operator'
    ),
    notIncludes: getTranslatedText(
      intl,
      'admin.slaPolicy.notIncludes.operator'
    ),
    on: getTranslatedText(intl, 'admin.slaPolicy.on.operator'),
    startsWith: getTranslatedText(intl, 'admin.slaPolicy.startsWith.operator')
  };
  return operatorMap;
};

const ALL_SHARD_MODULES = {
  ticket: 'Ticket',
  client: 'Client',
  requester: 'ClientUser',
  companyUser: 'User',
  asset: 'AssetClass',
  invoice: 'Billing'
};

const NEW_MODULE_MAP = {
  TICKET: 'Ticket',
  CLIENT: 'Client',
  CLIENT_USER: 'ClientUser',
  COMPANY_USER: 'User',
  ASSET_CLASS: 'AssetClass'
};

const ALL_MODULES = {
  ticket: 'TICKET',
  task: 'TASK',
  client: 'CLIENT',
  requester: 'CLIENT_USER',
  companyUser: 'COMPANY_USER',
  asset: 'ASSET_CLASS',
  mspAvatar: 'MSP_AVATAR',
  mspFavicon: 'MSP_FAV_ICON',
  clientAvatar: 'CLIENT_AVATAR',
  notificationTemplateAttachment: 'NOTIFICATION_TEMPLATE_ATTACHMENT',
  clientConversationAttachment: 'CLIENT_CONVERSATION_ATTACHMENT',
  clientAttachment: 'CLIENT_ATTACHMENT',
  invoice: 'INVOICE',
  ticketConversationAttachment: 'TICKET_CONVERSATION_ATTACHMENT',
  ticketNoteAttachment: 'TICKET_NOTE_ATTACHMENT',
  projectConversationAttachment: 'PROJECT_CONVERSATION_ATTACHMENT',
  assetAttachment: 'ASSET_ATTACHMENT',
  projectDetail: 'PROJECT_DETAIL',
  projectCreation: 'PROJECT_CREATION',
  trayIcon: 'TRAY_ICON',
  agentCustomBrandImage: 'AGENT_CUSTOM_BRAND_IMAGE',
  sideConversationAttachment: 'VENDOR_CONVERSATION_ATTACHMENT',
  assetDetails: 'ASSET_DETAILS',
  project: 'PROJECT',
  scheduling: 'SCHEDULING',
  quote: 'QUOTE'
};

const TAB_PAGES = {
  mailbox: 'MAIL_BOX',
  newInvoice: 'NEW_INVOICE',
  newQuote: 'NEW_QUOTE',
  quote: 'QUOTE',
  newInvoiceFromSource: 'NEW_INVOICE_FROM_SOURCE',
  scheduling: 'SCHEDULING',
  networkGraph: 'NETWORK_GRAPH'
};

const ENTITY_MAP = {
  ticket: 'Ticket',
  task: 'Task',
  client: 'Client',
  Client: 'Client',
  site: 'Site',
  user: 'User',
  alert: 'Alert',
  policy: 'Policy',
  asset: 'WorkStation',
  Android: 'Android',
  AppleIOS: 'AppleIOS',
  AppleIPadOS: 'AppleIPadOS',
  'asset-view': 'WorkStation',
  'asset-group': 'WorkStation',
  ReportingManager: 'ReportingManager',
  cpuMemData: 'AssetCPUMemData',
  patch: 'PatchDetail',
  patchDetail: 'PatchDetail',
  script: 'AssetScript',
  worklog: 'Worklog',
  offeredItem: 'OfferedItem',
  offereditem: 'OfferedItem',
  requester: 'Requester',
  clientuser: 'ClientUser',
  Site: 'Site',
  technician: 'Technician',
  techGroup: 'TechnicianGroup',
  technicianGroup: 'TechnicianGroup',
  RequesterAssociation: 'RequesterAssociation',
  project: 'Project',
  paymentMethod: 'PaymentMethod',
  invoicePaymentTerm: 'InvoicePaymentTerm',
  owner: 'ProjectOwner',
  ClientUser: 'ClientUser',
  'community-script': 'CommunityScript',
  antiVirusHealth: 'AntiVirusHealth',
  'patch-health': 'PatchHealth',
  invoice: 'Invoice',
  'offered-item': 'OfferedItem',
  AssetSoftwareInventory: 'AssetSoftwareInventory',
  nmasset: 'NMAsset',
  allassets: 'AllAssets',
  policyCategory: 'PolicyCategory',
  assetpatchdetail: 'AssetPatchDetail',
  assetSoftware: 'AssetSoftware',
  software: 'AssetSoftware',
  dataBackupHealth: 'DataBackupHealth',
  kbNumbers: 'PatchKb',
  workStation: 'WorkStation',
  workstation: 'WorkStation',
  workItem: 'WorkItem',
  serviceItem: 'ServiceItem',
  serviceTypeItem: 'ServiceTypeItem',
  serviceCatalogItem: 'ServiceCatalogItem',
  accountManager: 'AccountManager',
  primaryContact: 'PrimaryContact',
  secondaryContact: 'SecondaryContact',
  reportingManager: 'ReportingManager',
  AssetPatchDetail: 'AssetPatchDetail',
  accountmanager: 'AccountManager',
  primarycontact: 'PrimaryContact',
  secondarycontact: 'SecondaryContact',
  reportingmanager: 'ReportingManager',
  hoursworklogentry: 'HoursWorklogEntry',
  assetClass: 'AssetClass',
  Printer: 'Printer',
  assetMake: 'AssetMake',
  assetModel: 'AssetModel',
  Firewall: 'Firewall',
  Router: 'Router',
  Switch: 'Switch',
  Asset: 'Asset',
  IPAsset: 'IPAsset',
  ipAsset: 'IPAsset',
  IPCamera: 'IPCamera',
  LoadBalancer: 'LoadBalancer',
  PowerDistributionUnit: 'PowerDistributionUnit',
  Storage: 'Storage',
  UPS: 'UPS',
  VOIP: 'VOIP',
  WANAccelerator: 'WANAccelerator',
  WirelessAccessPoint: 'WirelessAccessPoint',
  WirelessLANController: 'WirelessLANController',
  WorkStation: 'WorkStation',
  NAS: 'NAS',
  survey: 'FeedbackSurvey',
  feedbacksurveyresponse: 'FeedbackSurveyResponse',
  FeedbackSurveyResponse: 'FeedbackSurveyResponse',
  monitoredAsset: 'MonitoredAsset',
  ServerHardwareController: 'ServerHardwareController',
  role: 'Role',
  assetremotesession: 'AssetRemoteSession',
  AssetRemoteSession: 'AssetRemoteSession',
  conversationthread: 'ConversationThread',
  contractApplicationRuleCondition: 'ContractApplicationRuleCondition',
  provisionRule: 'ProvisionRule',
  billing: 'Billing'
};

const COLOR_MAP = {
  blue: '#000ff0',
  white: '#ffffff',
  black: '#000000',
  lightBlue: 'var(--sops-light-blue)',
  green: '#77BB61',
  grey: '#ececec',
  red: '#de3730'
};

const PRIORITY_MAP = {
  1: 'critical',
  2: 'high',
  3: 'medium',
  4: 'low',
  5: 'very_low'
};

const APPROVAL_MAP = {
  'entityAttribute.requester.reportingManager': 'Reporting manager'
};

const CHAT_ACTION_TEXT = {
  TICKET_NOTE: 'ticket.details.chat.addNote',
  TICKET_CONVERSATION: 'ticket.details.chat.submit'
};

// Date format to send to backend
const DATE_FORMAT = 'YYYY-MM-DD';
const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

// Date formate for display
const DATE_FORMAT_MMM_DD_YYYY = 'MMM DD YYYY';
const TIME_FORMAT_HH_MM_A = 'hh:mm A';

// Map to specify how data should be sent to date-picker component
const DATE_PICKER_DATE_FORMAT = {
  'YYYY-MM-DD': 'yyyy-MM-dd',
  'YYYY-MM-DDTHH:mm:ss': 'yyyy-MM-dd h:mm aa'
};

// constants for support email settings and sales email settings
const MAIL_SETTINGS_TYPE = {
  support: 'SUPPORT',
  sales: 'SALES'
};

// Account types - If a requester is logged in, it will be client. Else it is msp.
const ACCOUNT_TYPE = {
  msp: 'MSP',
  client: 'CLIENT'
};

const TEXT_LENGTH = {
  size_1: 8,
  size_2: 20,
  size_3: 80,
  size_4: 100,
  size_5: 255,
  size_6: 500,
  size_7: 1000,
  size_8: 2000,
  size_9: 3000,
  size_10: 5000,
  size_60: 60
};

const PHONE_NUMBER_LENGTH = 25;

// View ids for client views
const CLIENT_VIEWS = {
  activeClients: '3001',
  allClients: '3002',
  myClients: '3003',
  prospects: '3004',
  trash: '3005',
  contracts: '1',
  invoiceAudit: '101',
  approvedItems: '102',
  ignoredItems: '103',
  allInvoices: '32',
  overdueInvoices: '33',
  unpaidInvoices: '34',
  recentlyPaidInvoices: '35',
  paidInvoices: '36',
  invoiceSettings: '301',
  paymentSettings: '302'
};

// View ids for mailboxViews
const MAILBOX_VIEWS = {
  newConversations: '5001',
  clientCommunications: '5002',
  prospectCommunications: '5003',
  allConversations: '5004',
  sentEmails: '5005',
  unknownEmails: '5006',
  clientAllConversations: '5008',
  clientNewConversations: '5007',
  clientSentEmails: '5009',
  clientTrashEmails: '5010',
  sideConversations: '5011',
  invoiceConversations: '5012'
};

const QUOTE_VIEWS = {
  all: '24',
  drafts: '25',
  pending: '26',
  approved: '27',
  closed: '28'
};

const QUOTE_VIEWS_CLIENT = {
  pending: '21',
  approved: '22',
  closed: '23'
};
// Hide disable button for email template ids
const ALWAYS_ACTIVE_TEMPLATES = {
  technicianPasswordReset: '3002',
  requestorPasswordReset: '3005'
};

// View IDs for Patch
const PATCH_VIEWS = {
  allPatches: '1001',
  latestPatches: '1002',
  pendingApproval: '1003',
  failedPatches: '1004'
};

// View IDs for Alert
const ALERT_VIEWS = {
  allAlerts: '1013'
};

/**
 * This is the ENUM for ticket source.
 */
const TICKET_SOURCE = {
  Email: 'Email',
  Phone: 'Phone',
  Form: 'Form',
  Agent: 'Agent',
  Ai: 'AI',
  Schedule: 'Schedule',
  SubscriptionReminder: 'Contract Reminder',
  Integration: 'Integration',
  Communication: 'Instant Messaging'
};

/**
 * Non taxable clients. i.e., the clients from these places don't have individual item taxes
 */

const NO_ITEM_TAX_CLIENTS = ['US'];

// Invoice status constants

const INVOICE_STATUS = {
  DRAFT: {
    label: 'invoice.generation.status.draft',
    color: '#f0f0f6',
    value: 'DRAFT',
    dropDownValue: 'Draft'
  },
  APPROVED: {
    label: 'invoice.generation.status.approved',
    color: '#CCE6F9',
    value: 'APPROVED',
    dropDownValue: 'Sent'
  },
  PAID: {
    label: 'invoice.generation.status.paid',
    color: '#CDF3C8',
    value: 'PAID',
    dropDownValue: 'Paid'
  },
  OVERDUE: {
    label: 'invoice.generation.status.overdue',
    color: '#FFC2B5',
    value: 'OVERDUE',
    dropDownValue: 'Overdue'
  },
  VOID: {
    label: 'invoice.generation.status.void',
    color: '#EEEEEE',
    value: 'VOID',
    dropDownValue: 'Void'
  },
  IN_GENERATION: {
    label: 'invoice.generation.status.inGeneration',
    color: '#ececec',
    value: 'IN_GENERATION',
    dropDownValue: 'In Generation'
  },
  PAYMENT_IN_PROGRESS: {
    label: 'invoice.generation.status.paymentInProgress',
    color: '#CDF3C8',
    value: 'PAYMENT_IN_PROGRESS',
    dropDownValue: 'Payment in progress'
    // errorMessage: 'invoice.generation.status.paymentInProgress.errorMessage'
  },
  PARTIALLY_PAID: {
    label: 'invoice.partialPayment.generation.status.partiallyPaid',
    color: '#FDE9B3',
    value: 'PARTIALLY_PAID',
    dropDownValue: 'Partially Paid'
  }
};

const QUOTE_STATUS = {
  DRAFT: {
    label: 'quote.details.status.draft',
    color: '#f0f0f6',
    value: 'DRAFT',
    dropDownValue: 'Draft'
  },
  APPROVED: {
    label: 'quote.details.status.approved',
    color: '#CCE6F9',
    value: 'APPROVED',
    dropDownValue: 'Approved'
  },
  PENDING: {
    label: 'quote.details.status.pending',
    color: '#CDF3C8',
    value: 'PENDING',
    dropDownValue: 'Pending'
  },
  REJECTED: {
    label: 'quote.details.status.rejected',
    color: '#FFC2B5',
    value: 'REJECTED',
    dropDownValue: 'Rejected'
  },
  EXPIRED: {
    label: 'quote.details.status.expired',
    color: '#EEEEEE',
    value: 'EXPIRED',
    dropDownValue: 'Expired'
  }
};

const ANTIVIRUS_INTEGRATION_CONSTANTS = {
  policyName: 'Managed Av'
};

const INTEGRATION_CONNECTION_STATUS = {
  connected: 'CONNECTED',
  reconnect: 'RECONNECT'
};

const DATE_FORMAT_FOR_DATE_PICKER = {
  'DD/MM/YYYY': 'dd/MM/yyyy',
  'MM/DD/YYYY': 'MM/dd/yyyy',
  'YYYY/MM/DD': 'yyyy/MM/dd',
  'DD MMMM YYYY': 'dd MMMM yyyy',
  'MMMM DD, YYYY': 'MMMM dd, yyyy',
  'DD MMM YYYY': 'dd MMM yyyy',
  'MMM DD, YYYY': 'MMM dd, yyyy',
  'dddd, DD MMM YYYY': 'eeee, dd MMM yyyy',
  'dddd, MMM DD, YYYY': 'eeee, MMM dd, yyyy',
  'ddd, DD MMM YYYY': 'eee, dd MMM yyyy',
  'ddd, MMM DD, YYYY': 'eee, MMM dd, yyyy',
  'DD-MM-YYY': 'dd-MM-yyyy',
  'MM-DD-YYYY': 'MM-dd-yyyy',
  'YYYY-MM-DD': 'yyyy-MM-dd'
};

const TAX_ROUND_OFF = 4;
const CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME = 'alldocuments';

const CUSTOM_FIELDS = {
  depedantField: 'DEPENDANT_FIELD',
  secureText: 'SECURE_TEXT',
  url: 'URL',
  totp: 'TOTP'
};
/* add the plans in lower case */
const RMM_ONLY_PLANS = ['standard-rmm', 'connect', 'standard-rmm-2024'];
const PSA_ONLY_PLANS = [
  'starter',
  'rise',
  'grow',
  'standard-psa',
  'standard-psa-2024'
];

export {
  CURRENCY_LIST,
  CURRENCY_SYMBOL_MAP,
  getLocaleCode,
  formatCurrency,
  INTL_UNSUPPORTED_CURRENCIES
} from './currency';
export * from './integrations';
export * from './ruleBuilder';
export * from './calendar';
export {
  StateCountryLabel,
  StateListDropDown,
  GET_CONSTANTS,
  CountryListDropDown
} from '@nile/components/src/Constants/stateslist/index';
export {
  ALL_MODULES,
  APPROVAL_MAP,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  DATE_PICKER_DATE_FORMAT,
  DATE_FORMAT_MMM_DD_YYYY,
  TIME_FORMAT_HH_MM_A,
  ENTITY_MAP,
  MAIL_SETTINGS_TYPE,
  ACCOUNT_TYPE,
  COLOR_MAP,
  PRIORITY_MAP,
  TEXT_LENGTH,
  CHAT_ACTION_TEXT,
  CLIENT_VIEWS,
  TICKET_SOURCE,
  NO_ITEM_TAX_CLIENTS,
  INVOICE_STATUS,
  ANTIVIRUS_INTEGRATION_CONSTANTS,
  PATCH_VIEWS,
  ALERT_VIEWS,
  INTEGRATION_CONNECTION_STATUS,
  MAILBOX_VIEWS,
  TAB_PAGES,
  ALWAYS_ACTIVE_TEMPLATES,
  OPERATORMAP,
  PHONE_NUMBER_LENGTH,
  DATE_FORMAT_FOR_DATE_PICKER,
  QUOTE_STATUS,
  QUOTE_VIEWS,
  QUOTE_VIEWS_CLIENT,
  TAX_ROUND_OFF,
  CLIENT_PORTAL_IT_DOC_DEFAULT_ENTITY_NAME,
  CUSTOM_FIELDS,
  RMM_ONLY_PLANS,
  PSA_ONLY_PLANS,
  ALL_SHARD_MODULES,
  NEW_MODULE_MAP
};
export * from './tableConstants';
export * from './planRestrictions';
export * from './fieldsContants';
export * from './RMM';
export * from './Common';
export * from './PSA';
